import { useFeatureFlag } from '@order/LaunchDarkly';

export const useIsMaintenanceModeEnabled = () => {
  return useFeatureFlag('OPS-enable-maintenance-mode', {
    listenForChanges: true,
  });
};
